module.exports = "<div class=\"col-md-12\">\n    <div class=\"form-group\" [formGroup]=\"group\">\n      <mat-form-field>\n          <mat-select [formControlName]=\"config.name\" [placeholder]=\"config.label\">\n              <mat-option *ngFor=\"let option of config.options\" [value]=\"option\">\n                  {{ option }}\n              </mat-option>\n          </mat-select>\n      </mat-form-field>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/dynamic-form/components/form-select/form-select.component.html
// module id = ./src/app/modules/shared/dynamic-form/components/form-select/form-select.component.html
// module chunks = main